import React from "react";
import Link from "next/link";

import { User } from "src/lib/graphql/types";
import { toJpeg } from "src/lib/imageCompressor";

type UserProfileSidebarProps = {
  user: User;
};

const UserProfileSidebar = ({ user }: UserProfileSidebarProps) => {
  return (user?.memberOf || [])?.length > 0 ? (
    <div className="index-profile-sidebar large-text">
      <div className="container">
        <div className="bold sidebar-field">
          <div className="field-label">Organizations</div>
          <div className="user-org-links">
            {user?.memberOf?.map(
              (info) =>
                info.org && (
                  <Link
                    href={`/@${info.org.shortname}`}
                    key={info.org!.shortname}
                  >
                    <a>
                      <img
                        src={toJpeg(info.org.avatar, 100)}
                        alt={`${info.org.name}'s profile`}
                      />
                    </a>
                  </Link>
                )
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default UserProfileSidebar;
